export default "__VITE_ASSET__CNbSdpKp__"